export default __webpack_public_path__ + "images/83c5877e2c1c90bf080284ba0e42e1a1.svg";